export function blogToc() {
    const isABlog = document.querySelector('.single-content');
    if (!isABlog) return;

    const headersH2 = document.querySelectorAll('.content-wrap h2');
    const headersH3 = document.querySelectorAll('.content-wrap h3');

    const targetUl = document.querySelector('.content-wrap ul');
    if (!targetUl) return;

    const listItems = Array.from(targetUl.querySelectorAll('li'));

    const usedSlugs = new Set();

    if (headersH2.length) linkTitlesToTOC(headersH2, listItems);
    if (headersH3.length) linkTitlesToTOC(headersH3, listItems);

    function stringToSlug(str) {
        const from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
        const to   = "aaaaeeeeiiiioooouuuunc------";
        let result = (str || '').trim().toLowerCase();
        for (let i = 0; i < from.length; i++) {
            result = result.replace(new RegExp(from[i], 'g'), to[i]);
        }
        return result
            .replace(/[^a-z0-9 -]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');
    }

    function normalizeText(str) {
        return stringToSlug(str).replace(/-/g, ' ').trim();
    }

    function linkTitlesToTOC(titles, list) {
        titles.forEach(header => {
            const headerText = header.textContent.trim();
            if (!headerText) return;

            const slug = stringToSlug(headerText);
            if (usedSlugs.has(slug)) return; 
            const el = header; el.id = slug;

            const normHeader = normalizeText(headerText);
            const matchItem = list.find(item => {
                if (!item || item.querySelector('a')) return false;
                const liText = item.textContent.trim();
                if (!liText) return false;

                const normLi = normalizeText(liText);

                const hWords = normHeader.split(/\s+/).filter(Boolean);
                const lWords = new Set(normLi.split(/\s+/).filter(Boolean));
                const matched = hWords.filter(w => lWords.has(w)).length;
                const threshold = Math.max(2, Math.ceil(hWords.length * 0.6));
                return matched >= threshold;
            });

            if (matchItem) {
                const liText = matchItem.textContent.trim();
                const link = document.createElement('a');

                link.href = `#${slug}`;
                link.textContent = liText;

                while (matchItem.firstChild) matchItem.removeChild(matchItem.firstChild);
                matchItem.appendChild(link);

                usedSlugs.add(slug);
            }
        });
    }
}
